export const issueVouchers = {
  title: '出库单',
  titles: {
    create: '新增出库单',
    edit: '编辑出库单',
    detail: '出库单详情',
    list: '出库单列表',
    addQuick: '快速添加',
  },
  sections: {
    linkage: '仓库、客户与相关人员',
    note: '备注',
    detail: '单据信息',
  },
  fields: {
    code: '单号',
    warehouse: '仓库',
    customer: '客户',
    createdBy: '创建人',
    deliverer: '交货人',
    confirmer: '确认人',
    status: '状态',
    batches: '批次',
    note: '备注',
    actions: '操作',
    createdAt: '创建时间',
    updatedAt: '更新时间',
  },
  statusValues: {
    PENDING: '待处理',
    IN_PROGRESS: '处理中',
    DELIVERED: '已交货',
    CANCELLED: '已取消',
  },
  actions: {
    confirmProgress: '确认进度',
    confirmDelivered: '确认已交货',
  },
  messages: {
    noData: '暂无数据',
  },
  filter: {
    placeholder: '按单号、仓库、客户搜索...',
  },
  validation: {
    atLeastOneBatch: '请至少选择一个批次',
  },
}
